import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { STATS_EVENT_TYPES } from "zstats";
import { useStats } from "contexts/stats";
import { useSelector } from "react-redux";

export function TrackSections() {
    const location = useLocation();
    const stats = useStats();
    const prevSectionRef = useRef(null);

    const { selectedHotel, selectedLandings, selectedRooms } = useSelector((s) => s.session);
    const mainLandingRef = selectedLandings?.[selectedHotel]?.mainLandingRef || null;
    const landingRef = selectedLandings?.[selectedHotel]?.landingRef || null;
    const screenSelected = landingRef !== mainLandingRef ? landingRef : null;
    const selectedRoom = selectedRooms?.[selectedHotel];
    const landingName = useSelector((s) => s.session?.LandingName);

    useEffect(() => {
        const sectionKey = getLayoutKey({
            path: location.pathname,
            selectedHotel,
            selectedLandings,
            screenSelected,
            landingName,
        });

        if (!sectionKey) return;

        console.log("Tracking section:", sectionKey);
        console.log("Prev section:", prevSectionRef.current);

        if (prevSectionRef.current !== sectionKey) {
            if (prevSectionRef.current) {
                stats?.endDurationEvent({ eventName: prevSectionRef.current });
            }
            prevSectionRef.current = sectionKey;
            stats?.startDurationEvent({
                type: STATS_EVENT_TYPES.SECTION,
                eventName: sectionKey,
            });
        }
    }, [location.pathname, selectedHotel, selectedLandings, selectedRoom, screenSelected, landingName, stats]);

    useEffect(() => {
        return () => {
            if (prevSectionRef.current) {
                stats?.endDurationEvent({ eventName: prevSectionRef.current });
                prevSectionRef.current = null;
            }
        };
    }, [stats]);

    return null;
}

export const getLayoutKey = ({ path, selectedHotel, selectedLandings, screenSelected, landingName }) => {
    if (!path) return null;

    const cleanPath = path.split(/[?#]/)[0].replace(/\/$/, "");

    const exactMatches = new Map([
        ["/", "HOME"],
        ["/stays", "staybookings"],
        ["/sales", "roomshops"],
        ["/profile", "profile"],
        ["/notifications", "notifications"],
        ["/site/booking", "booking"],
        ["/site/zones", "zones"],
        ["/checkout/bills", "bill"],
        ["/checkout", "checkout"],
        ["/keys", "keys"],
        ["/maps", "Maps"],
        ["/satisfaction", "satisfaction"],
    ]);

    if (exactMatches.has(cleanPath)) return exactMatches.get(cleanPath);

    if (cleanPath === "/site") {
        const hasLandingForHotel = !!selectedLandings?.[selectedHotel];
        if (hasLandingForHotel) {
            if (!landingName) return null;

            if (screenSelected) return landingName;

            return "HOME";
        }
    }

    if (cleanPath.includes("/maps")) return "Maps";

    if (cleanPath.includes("/signup/privacy")) return "privacypolicy";
    if (cleanPath.includes("/signup/terms")) return "terms";
    if (cleanPath.includes("/signup")) return "signup";
    if (cleanPath.includes("/signin")) return "signin";
    if (cleanPath.includes("/signout")) return "signout";
    if (cleanPath.includes("addroom") && !cleanPath.includes("signin") && !cleanPath.includes("signup")) {
        return "addroom";
    }
    if (cleanPath.startsWith("/sales/orders")) return "orders";
    if (cleanPath.startsWith("/sales")) return "roomshops";
    if (cleanPath.includes("/stays")) return "staybookings";
    if (cleanPath === "/messages") return "messages";

    return null;
};
